require('../../modules/es6.math.cosh');
module.exports = require('../../modules/_core').Math.cosh;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/cosh.js
// module id = 1451
// module chunks = 0